export enum TimeEntryType {
  Regular,
  Absence,
  Overtime,
  Additional,
  Deduction,
}
